// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"DashboardPage_contentContainer_ha5Dk","headerMarginBottom":"DashboardPage_headerMarginBottom_thmhO","spinAround":"DashboardPage_spinAround_HsIUA"};